module.exports = __webpack_public_path__ + "static/media/About-ITS.a09aeacc.jpg";